import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from 'mdbreact';
import { CSVLink } from "react-csv";
import Loading from "../Loading";
import { dateFormat, timeFormat } from "../../../../dynamicController";

const mySwal = withReactContent(Swal);

const TokenDetailReportCard = ({ token }) => {

    const { t } = useTranslation();

    const location = useLocation();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])

    useEffect(() => {
        if (location.state) {
            setLoading(true)
            axios
                .post("/api/admin/report/token/detail", location.state, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data)
                    setLoading(false)
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error")
                });
        }
    }, [])

    let tableData = {
        columns: [
            {
                label: t("User Name"),
                field: "name",
                sort: "asc"
            },
            {
                label: t("Phone Number"),
                field: "number",
                sort: "asc"
            },
            {
                label: t("Email Address"),
                field: "email",
                sort: "asc"
            },
            {
                label: t("Member ID"),
                field: "memberId",
                sort: "asc"
            },
            {
                label: t("e-Token Spent"),
                field: "tokenSpent",
                sort: "asc"
            },
            {
                label: t("Machine Type"),
                field: "machineType",
                sort: "asc"
            },
            {
                label: t("Transaction ID"),
                field: "transactionId",
                sort: "asc"
            },
            {
                label: t("Transaction Date"),
                field: "date",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            },
        ],
        rows: data
    };

    let csv = [];

    if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const dataObject = {
                ...data[i],
                number: `=""${data[i].number}""`,
            }
            csv.push(dataObject)
        }
    }

    const csvData = {
        headers: [
            { label: "User Name", key: "name" },
            { label: "Phone Number", key: "number" },
            { label: "Email Address", key: "email" },
            { label: "Member ID", key: "memberId" },
            { label: "e-Token Spent", key: "tokenSpent" },
            { label: "Machine Type", key: "machineType" },
            { label: "Transaction ID", key: "transactionId" },
            { label: "Transaction Date", key: "date" },
            { label: "Status", key: "status" }
        ],
        data: csv
    };

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="card-title">{t("e-Token Detailed Report")} ({location.state?.outletName})</h5>
            </div>

            <div className="card-body">
                {
                    loading ? <Loading /> : (
                        <div className="text-center">
                            <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename={`etoken_detail_report_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                    {t("Download Report")}
                                </CSVLink>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default TokenDetailReportCard;